import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import { useClipboard } from '@perpay-web/fintech/hooks/useClipboard';
import { noop } from '@perpay-web/utils/noop';

const CopyButton = ({
    textElementRef,
    // We leave this undefined so the default within setClipboard is used.
    valueGetter = undefined,
    childGetter = undefined,
    onClick = noop,
    // We leave the fail callback undefined so that if the promise rejects,
    // the error is not swallowed. We leave the success one undefined to make them match.
    onCopySuccess = undefined,
    onCopyFail = undefined,
    ...rest
}) => {
    const { message, setClipboard } = useClipboard();

    return (
        <CustomButton
            {...rest}
            onClick={() => {
                onClick();
                setClipboard(textElementRef, valueGetter, childGetter).then(
                    onCopySuccess,
                    onCopyFail,
                );
            }}
        >
            {message}
        </CustomButton>
    );
};

export default CopyButton;
